import React, { useState, useMemo } from 'react'
import styled from 'styled-components'

type buttonPushableProps = {
    isEnabled: boolean
    buttonContent?: string
    onClick: () => void
    isSelected: boolean
}

export const ButtonPushable = ({ isEnabled, buttonContent, onClick, isSelected }: buttonPushableProps): JSX.Element => {
    const [isButtonSelected, setIsButtonSelected] = useState(isSelected)

    const toggleButtonSelected = () => {
        if (isEnabled) {
            setIsButtonSelected(!isButtonSelected)
            onClick()
        }
    }

    return useMemo(
        () => (
            <Button
                type="button"
                isButtonEnabled={isEnabled}
                isButtonSelected={isButtonSelected}
                onClick={toggleButtonSelected}
            >
                <i className={buttonContent} />
            </Button>
        ),
        [isEnabled, buttonContent, onClick, isButtonSelected]
    )
}

const Button = styled.button<{ isButtonEnabled: boolean; isButtonSelected: boolean }>`
    height: 24px;
    width: 43px;
    border: none;
    border-radius: 3px;
    justify-content: center;
    color: ${({ isButtonEnabled, theme }) =>
        isButtonEnabled ? theme?.['gray-800'] || '#364159' : theme?.['gray-400'] || '#C8CCD4'};
    background-color: ${({ isButtonSelected, isButtonEnabled, theme }) =>
        isButtonSelected && isButtonEnabled ? theme?.['gray-600'] || '#868695' : theme?.['gray-300'] || '#DDDEE1'};
`
